import { Component, Input, OnInit, AfterViewInit, CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { RequirementItems } from '@app/core/interfaces/RequirementChecklist';
import { faExclamationCircle, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-document-status-chip',
    templateUrl: './document-status-chip.component.html',
    styleUrls: ['./document-status-chip.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class DocumentStatusChipComponent {
    //icons
    faExclamationCircle = faExclamationCircle;
    faCheckCircle = faCheckCircle;
    @Input() checklist: RequirementItems[] = [];

    @Input() type?: string;

    @Input() requirementId?: string;

    constructor() {}
}
